import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderHistorySearchTagsStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags";
import { css } from "styled-components";

orderHistorySearchTagsStyles.appliedFiltersContainer = mergeToNew(
    orderHistorySearchTagsStyles.appliedFiltersContainer,
    {
        css: css`
            &:not(:empty) {
               margin-bottom: 16px;
            }
        `,
    },
);
